import {
  ALL_QUERY_PARAM_VALUE,
  ASSET_ID_QUERY_PARAM,
  PHASE_QUERY_PARAM,
  STATUS_QUERY_PARAM,
} from '../config'

export function getDocumentsUrl(options: { assetId?: string } = {}) {
  return `/${options.assetId ? `?${ASSET_ID_QUERY_PARAM}=${options.assetId}&${PHASE_QUERY_PARAM}=${ALL_QUERY_PARAM_VALUE}&${STATUS_QUERY_PARAM}=${ALL_QUERY_PARAM_VALUE}` : ''}`
}

export function getDocumentsUrlWithCurrentParams() {
  const currentSearchParams = new URLSearchParams(window.location.search)
  return currentSearchParams.toString()
    ? `${getDocumentsUrl()}?${currentSearchParams.toString()}`
    : `${getDocumentsUrl()}`
}
